// Small drawn sparkline — area + line, coloured by direction (down = red / up = green). Falls back
// to a dashed baseline when the series is too thin to trend honestly.
export function Sparkline({
  pts,
  down,
  id,
  w = 64,
  h = 22,
  area = true,
}: { pts: number[]; down: boolean; id: string; w?: number; h?: number; area?: boolean }) {
  const pad = 3
  if (pts.length < 2) {
    return (
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden="true">
        <line
          x1={pad}
          y1={h / 2}
          x2={w - pad}
          y2={h / 2}
          stroke="rgb(var(--faint-rgb))"
          strokeWidth="1.4"
          strokeDasharray="2 3"
          opacity="0.6"
        />
      </svg>
    )
  }
  const mn = Math.min(...pts)
  const mx = Math.max(...pts)
  const r = mx - mn || 1
  const col = down ? 'rgb(var(--down-rgb))' : 'rgb(var(--up-rgb))'
  const X = (i: number) => pad + (i / (pts.length - 1)) * (w - 2 * pad)
  const Y = (v: number) => h - pad - ((v - mn) / r) * (h - 2 * pad)
  const last = pts[pts.length - 1] ?? mn
  const line = `M${pts.map((v, i) => `${X(i).toFixed(1)},${Y(v).toFixed(1)}`).join(' L')}`
  const fill = `${line} L${X(pts.length - 1).toFixed(1)},${h - pad} L${X(0).toFixed(1)},${h - pad} Z`
  const gid = `spk${id}`
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden="true">
      {area && (
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor={col} stopOpacity="0.22" />
            <stop offset="1" stopColor={col} stopOpacity="0" />
          </linearGradient>
        </defs>
      )}
      {area && <path d={fill} fill={`url(#${gid})`} />}
      <path d={line} fill="none" stroke={col} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={X(pts.length - 1).toFixed(1)} cy={Y(last).toFixed(1)} r="1.9" fill={col} />
    </svg>
  )
}
